import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { TooltipProps } from './styles';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import * as state from '@/components/Analysis/state';
import { primary } from '@/theme/colors';
import { theme } from '@/theme/theme';

type CheckBoxProps = {
  templateId: string;
  disabled?: boolean;
  onChange: () => void;
};

const CheckBoxComponent = ({ templateId, disabled = false, onChange }: CheckBoxProps) => {
  const selectedTemplates = useAtomValue(state.pointOfInterestTemplates);

  const isTemplateSelected = useCallback(
    (templateId: string) => {
      return selectedTemplates.some((template) => template.id === templateId);
    },
    [selectedTemplates]
  );
  return (
    <Checkbox
      checked={!disabled && isTemplateSelected(templateId)}
      disabled={disabled}
      onChange={onChange}
      sx={{
        color: primary.main,
        '&.Mui-checked': {
          color: theme.palette.common.darkBlue,
        },
      }}
    />
  );
};

type Props = {
  disabled: boolean;
  templateId: string;
  templateName: string;
  onChange: () => void;
};

export const TemplateCheckBox = ({ disabled, templateId, templateName, onChange }: Props) => {
  return (
    <Tooltip
      title={disabled ? `${templateName} is not present` : ''}
      arrow
      placement="right"
      componentsProps={TooltipProps}
    >
      <FormControlLabel
        data-testid={`poi-checkbox-${templateId}`}
        value={templateId}
        disabled={disabled}
        sx={{ width: 'fit-content' }}
        control={
          <CheckBoxComponent templateId={templateId} disabled={disabled} onChange={onChange} />
        }
        label={templateName}
      />
    </Tooltip>
  );
};
